{
  "dss": {
    "button": {
      "back": "Indietro",
      "cancel": "Annulla",
      "close": "Chiudi",
      "confirmDelete": "Sì, elimina",
      "continue": "Continua",
      "logout": "Disconnetti",
      "passwordReset": "Reimposta password",
      "save": "Salva",
      "verify": "Verifica"
    },
    "error": {
      "403": "Non avete accesso a questa pagina.",
      "404": "Questa pagina non esiste.",
      "generic": "Purtroppo si è verificato un errore. Riprova.",
      "invalidConfirmationLink": "Il link di conferma è scaduto o non è valido.",
      "throttling": "Troppi tentativi. Questa operazione è bloccata per un po' di tempo.",
      "title": "Errore",
      "title403": "Accesso vietato",
      "title404": "Non trovato"
    },
    "footer": {
      "imprint": "Impronta",
      "legalEntity": "Andreas STIHL S.p.A. - Viale delle Industrie, 15 - 20040 Cambiago (MI)",
      "privacy": "Protezione dei dati",
      "terms": "Termini e condizioni"
    },
    "label": {
      "CRMAccountNumber": "Numero di conto CRM",
      "contact": "Contatto",
      "email": "Email",
      "faq": "FAQ",
      "female": "Ms.",
      "firstname": "Nome",
      "help": "Aiuto",
      "language": "Lingua",
      "lastname": "Cognome",
      "male": "Il Sig.",
      "needHelp": "ho bisogno di aiuto?",
      "newPassword": "Nuova password",
      "newPassword2": "Ripeti nuova password",
      "oldPassword": "Password attuale",
      "organization": "Organizzazione",
      "password": "Password",
      "required": "richiesto",
      "salutation": "Formula Di Saluto",
      "select": "Si prega di selezionare"
    },
    "lang": {
      "it": "Italiano"
    },
    "link": {
      "contact": "https://support.stihl.com/it-IT/websso-contact/",
      "faq": "https://support.stihl.com/it-IT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Confermare la registrazione",
        "wait": "Attendere per completare la conferma dell'account."
      },
      "otp": {
        "btnResend": "Reinvia codice di verifica",
        "msg": {
          "invalidOTP": "La password unica inserita non è valida.",
          "resendFail": "Non è stato possibile inviare nuovamente il codice. Riprovare più tardi."
        },
        "spamDetail": "Cerca nella tua posta e nella tua cartella spam una mail proveniente da STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Non hai ricevuto la mail?",
        "subtitle": "Per continuare, è necessario verificare il proprio indirizzo e-mail..",
        "title": "Verifica dell'account utente",
        "txtVerifyMail": "Inserisci il nuovo codice di verifica che ti abbiamo inviato al tuo indirizzo e-mail. {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Non c'è nulla da aggiornare.",
          "updateError": "Mancato aggiornamento dei dati personali.",
          "updated": "I dati personali sono stati aggiornati.",
          "userLoadErr": "Errore nel caricamento dei dati utente. Riprovare più tardi."
        },
        "secOrganization": "Organization",
        "secPersonal": "Personali",
        "secSettings": "Impostazioni preferite",
        "title": "Informazioni personali"
      },
      "postPwSet": {
        "info": "Ora puoi utilizzare la tua nuova password",
        "link_name": "Proseguire con il self-service",
        "link_url": "/user/ui/",
        "title": "La tua password è stata modificata"
      },
      "resetPW": {
        "title": "Reimpostare la password"
      },
      "security": {
        "2fa": {
          "availableMethods": "Metodi 2FA disponibili:",
          "info": "L'autenticazione a due fattori (2FA) è una funzione di sicurezza che aggiunge un livello di protezione extra al tuo account. Richiede l'utilizzo di due metodi per effettuare l'accesso, invece di un semplice nome utente e password.",
          "method": {
            "email": "Email",
            "emailDesc": "Ricevi codici unici inviati via email per completare le richieste di autenticazione.",
            "oath": {
              "add": {
                "button": "Registra app di autenticazione"
              }
            }
          }
        },
        "authenticator": "App di autenticazione",
        "infoFederatedAccount": "Questo account è gestito dal provider di identità della tua organizzazione, quindi la password non può essere modificata qui. Per cambiare la password, accedi tramite la pagina di accesso della tua organizzazione o contatta il tuo amministratore IT.",
        "lastUse": "Ultimo utilizzo alle {0}.",
        "msg": {
          "invalidPassword": "Password attuale non valida.",
          "passwordAlreadyUsed": "Non è possibile riutilizzare le ultime 5 password.",
          "pwUpdateError": "Si è verificato un errore durante il tentativo di cambiare la password.",
          "pwUpdated": "La password è stata modificata."
        },
        "noDevice": "Non configurato",
        "oathAdd": {
          "appInfo": "Le app di autenticazione come {0}, {1}, ecc. generano password monouso che vengono utilizzate come secondo fattore durante l'accesso.",
          "badCode": "Codice non valido, riprova.",
          "error": "Si è verificato un errore durante il tentativo di registrare il dispositivo di autenticazione.",
          "headScan": "1. Scansiona il codice QR con la tua app di autenticazione",
          "headVerify": "2. Verifica il codice",
          "infoKey": "chiave di configurazione",
          "infoKeyTitle": "Il tuo segreto a due fattori",
          "infoScanBottom": "Impossibile eseguire la scansione? Puoi utilizzare {0} per configurare manualmente la tua app di autenticazione.",
          "infoVerify": "Inserisci il codice generato dalla tua app di autenticazione.",
          "success": "Il tuo dispositivo di autenticazione è stato registrato. Ora puoi usarlo per accedere.",
          "title": "Registra il tuo dispositivo di autenticazione a due fattori"
        },
        "oathDelete": {
          "error": "Si è verificato un errore durante il tentativo di eliminare il dispositivo di autenticazione.",
          "success": "Il dispositivo di autenticazione è stato eliminato."
        },
        "passkeys": {
          "about": {
            "info1": "Le chiavi di accesso sono coppie di chiavi crittografiche (una chiave pubblica e una chiave privata) che vengono memorizzate in un autenticatore controllato da te. L'autenticatore può dimostrare che l'utente è presente ed è autorizzato a utilizzare la chiave di accesso. Gli autenticatori dimostrano l'autorizzazione tramite un PIN, una password, dati biometrici o la password del dispositivo, a seconda delle funzionalità e della configurazione dell'autenticatore. Gli autenticatori possono assumere varie forme, come un iPhone o un dispositivo Android, Windows Hello, una chiave di sicurezza hardware FIDO2 o un gestore di password.",
            "info2": "Quando accedi a STIHL utilizzando una chiave di accesso, il tuo autenticatore utilizza la crittografia a chiave pubblica per dimostrare la tua identità a STIHL senza mai inviare la chiave di accesso. Le chiavi di accesso sono legate a un dominio del sito web, come stihl-sso.com, e richiedono una connessione sicura, il che significa che il browser web rifiuterà di autenticarsi su un sito di phishing. Queste proprietà rendono le chiavi di accesso altamente resistenti al phishing e molto più difficili da attaccare rispetto a metodi come SMS o TOTP 2FA, che possono essere vulnerabili al phishing.",
            "info3": "I servizi di chiavi di accesso basati su cloud consentono di sincronizzare le chiavi di accesso tra dispositivi (come dispositivi Apple, Android o gestori di password) per renderle accessibili da più luoghi e meno soggette a smarrimento. Una volta configurata una chiave di accesso sincronizzata su un dispositivo, questa sarà disponibile per l'uso su più dispositivi che utilizzano lo stesso servizio. Ad esempio, se registri una chiave di accesso con il tuo account iCloud utilizzando il Touch ID del tuo MacBook, puoi quindi utilizzare quella chiave con il tuo viso, impronta digitale, PIN o password del dispositivo su più dispositivi collegati allo stesso account iCloud.",
            "title": "Informazioni sulle chiavi di accesso"
          },
          "add": {
            "button": "Aggiungi una nuova chiave di accesso",
            "error": "Si è verificato un errore durante il tentativo di aggiungere una nuova chiave di accesso.",
            "success": "Una nuova chiave di accesso è stata aggiunta."
          },
          "delete": {
            "button": "Elimina chiave di accesso",
            "error": "Si è verificato un errore durante il tentativo di eliminare questa chiave di accesso.",
            "success": "La chiave di accesso è stata eliminata."
          },
          "edit": {
            "error": "Si è verificato un errore durante il tentativo di salvare il nome della chiave di accesso.",
            "name": "Nome della chiave di accesso",
            "success": "Il nome della chiave di accesso è stato aggiornato.",
            "title": "Dai un nome alla tua chiave di accesso per distinguerla dalle altre chiavi di accesso"
          },
          "info": "La chiave di accesso è un'alternativa semplice e sicura alle password, che convalida la tua identità utilizzando il tocco, il riconoscimento facciale, una password del dispositivo o un PIN.",
          "none": "Nessuna chiave di accesso configurata.",
          "reallyDelete": "Sei sicuro di voler eliminare la chiave di accesso?",
          "registeredPasskeys": "Chiavi di accesso registrate:",
          "title": "Chiavi di accesso"
        },
        "reallyDeleteDevice": "Sei sicuro di voler eliminare il dispositivo di autenticazione?",
        "secMFA": "Autenticazione a più fattori",
        "secPwdChange": "Cambia password",
        "title": "Login & Sicurezza"
      },
      "setPW": {
        "acceptTC": "Please confirm our {terms} and read our {privacy}.",
        "killSSO": "Invalidare tutte le sessioni attive",
        "msg": {
          "tokenExpired": "Il link o il codice della password è scaduto. Seguire il link per reimpostare la password: {link}."
        },
        "privacy": "Informativa sulla privacy dei dati",
        "terms": "Termini e condizioni",
        "title": "Inserisci nuova password"
      }
    },
    "validations": {
      "hasDigit": "Deve contenere una o più cifre",
      "hasLowercase": "Deve contenere caratteri minuscoli",
      "hasSpecial": "Deve contenere caratteri speciali: {chars}",
      "hasUppercase": "Deve contenere caratteri maiuscoli",
      "invalidCharacters": "Contiene caratteri non consentiti",
      "maxLength": "Massimo {max} di caratteri consentiti",
      "minLength": "Minimo {min} caratteri",
      "notSameAsEmail": "Troppo simile all'indirizzo email",
      "onlyValidCharactersAllowed": "Sono consentiti solo lettere, numeri e spazi.",
      "required": "Valore richiesto",
      "sameAsPassword": "Le password non corrispondono",
      "tcAccepted": "Confermate i nostri termini e condizioni.",
      "validEmail": "Indirizzo e-mail non valido.",
      "validOTP": "Inserire il codice di verifica."
    }
  }
}
